import { ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { WalletAccountHttpProvider } from './helpers/provider/repository/http-repository.provider';

const DATA_SERVICES: Provider[] = WalletAccountHttpProvider;

export const NB_CORE_PROVIDERS = [...DATA_SERVICES];

@NgModule({})
export class WalletAccountCoreModule {
  static forRoot(): ModuleWithProviders<WalletAccountCoreModule> {
    return {
      ngModule: WalletAccountCoreModule,
      providers: [...NB_CORE_PROVIDERS],
    };
  }
}
